<template>
  <Aside class="aside-for-links">
    <div class="right-panel">
      <div class="tab-right">
        <span class="tab-label-text ">Online services</span>
        <span>
          Skip the trip! Use online DMV services below. Find links for your license and registration specific services underneath your License and Registration.
        </span>
        <div class="links">
          <ul>
            <li class="tab-content-list">
              <a href="javascript: void(0)" @click="newReservation()">Make a new Reservation </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </Aside>

  
</template>

<script>
import Aside from './Aside.vue';

export default {
  name: "AsideForLinks",
  components: {
    Aside,
  },
  data() {
    return {
      onlineToken: ''
    }
  },
  watch: {
    onlineToken(value) {
      console.log('Update value for data', value)
      window.close();
    },
    onlineTokenLocalStorage(value) {
      console.log('UPDATE VALUE for computed', value)
      window.close();
    }
  },
  computed: {
    onlineTokenLocalStorage() {
      return localStorage.getItem('onlineToken');
    }
  },
  mounted() {
  },
  methods: {
    newReservation() {
      // localStorage.setItem('trigger', '');
      // localStorage.setItem('onlineToken', encodeURIComponent(this.$store.state.guestLogin.accessToken));
      // this.onlineToken = localStorage.getItem('onlineToken');
      window.open(window.config.WEB_CLIENT_URL+'type?onlineToken='+ encodeURIComponent(this.$store.state.guestLogin.accessToken))
      // window.open('https://ridmvwebtest-dev.ri.gov/type?onlineToken='+ encodeURIComponent(this.$store.state.guestLogin.accessToken))
    }
  }
}
</script>

<style scoped lang="scss">
.app-notice {
  padding: 1rem;
  width: 20%;
}
.aside-for-links {
  img {
    margin-left: 0.5em;
    width: 0.75rem;
  }
  .right-panel{
    .tab-right {
      .tab-label-text{
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        cursor: pointer;
        margin-bottom: 1rem;
        &::after {
          content: none; 
        }
      }
      .links{
        ul {
          li {
            margin-top: 1rem;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 599px) {
  .app-notice {
    width: 100%;
    margin-top: 1rem;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1024px) {
  .app-notice {
    max-width: unset;
    width: unset;
    margin-top: 1rem;
  }
}
</style>